let ctx;
export const audioCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const freq = (midi) => 440 * Math.pow(2, (midi - 69) / 12);

export function playNotes(midis, { strum = 0, duration = 1.6, wave = "triangle" } = {}) {
  const c = audioCtx();
  const out = c.createGain();
  out.gain.value = 0.5 / Math.max(1, Math.sqrt(midis.length));
  const lp = c.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 2400;
  out.connect(lp).connect(c.destination);
  midis.forEach((m, i) => {
    const t = c.currentTime + i * strum;
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = wave;
    o.frequency.value = freq(m);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(1, t + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t + duration);
    o.connect(g).connect(out);
    o.start(t);
    o.stop(t + duration + 0.05);
  });
}
